/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerUpdateMutationRequest, ProjectTypesControllerUpdateMutationResponse, ProjectTypesControllerUpdatePathParams, ProjectTypesControllerUpdate400, ProjectTypesControllerUpdate401, ProjectTypesControllerUpdate403, ProjectTypesControllerUpdate404 } from "../../models/projectTypesController/ProjectTypesControllerUpdate";

function getProjectTypesControllerUpdateUrl(id: ProjectTypesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/project-types/${id}` as const }  
  return res
}

/**
 * @summary Update a project type
 * {@link /api/v1/project-types/:id}
 */
export async function projectTypesControllerUpdate(id: ProjectTypesControllerUpdatePathParams["id"], data?: ProjectTypesControllerUpdateMutationRequest, config: Partial<RequestConfig<ProjectTypesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectTypesControllerUpdateMutationResponse, ResponseErrorConfig<ProjectTypesControllerUpdate400 | ProjectTypesControllerUpdate401 | ProjectTypesControllerUpdate403 | ProjectTypesControllerUpdate404>, ProjectTypesControllerUpdateMutationRequest>({ method : "PATCH", url : getProjectTypesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}